import * as React from "react";

import { Paper, Chip, LinearProgress } from '@material-ui/core';

import { Query } from 'react-apollo';

import * as ReactTooltip from 'react-tooltip';

import './MarketBookstoreChip.scss';
import { QueryFilter, QUERY_FILTER_UPDATE_MARKET_BOOKSTORE } from "src/component/shared";
import { MARKET_BOOKSTORE_STORE_FILTER } from "src/component/market/bookstore/shared/filter/bookstore/MarketBookstoreStoreFilter";

export interface IChipData {
    key: number;
    label: string;
    filter: any;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketBookstoreChipProps {
    // data: IChipData[];
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketBookstoreChipState {
    data: IChipData[];
}

export class MarketBookstoreChip extends React.Component<IMarketBookstoreChipProps, IMarketBookstoreChipState> {

    constructor(props: IMarketBookstoreChipProps) {
        super(props);

        // Set initial state
        this.state = { data: [] };
    }

    public render() {
        return (<Query query={QUERY_FILTER_UPDATE_MARKET_BOOKSTORE}>
                    {({ loading, error, data, client }) => {
                        const arrayFilter = GetArrayFilters(data);

                        return (arrayFilter.length > 0 ?
                        <div id="chips" className="wrapper"><Paper>
                            <div className="filter-chip-bar">
                                {loading && <LinearProgress />}
                                {error && `Error! ${error.message}`}
                                {arrayFilter.map(
                                    (item: any) => {
                                        return (
                                        <div key={item.field}>
                                            <Query query={item.query}
                                                variables={QueryFilter.getFilterMarketBookstore(client, {
                                                    "customFilter": {
                                                            "isChart": true,
                                                    }
                                                }, [item.field], true)}>
                                                    {(dataFilter: any) => {
                                                        if (dataFilter.loading) {
                                                            return <Chip
                                                                key={item.key}
                                                                label={item.label}
                                                                onDelete={this.handleDelete({ key: item.key, label: item.label, filter: item }, client)}
                                                                className="filter-chip"
                                                            />;
                                                        }

                                                        return (
                                                            <div>
                                                                <a data-tip={true} data-for={item.field}>
                                                                    <Chip
                                                                        key={item.key}
                                                                        label={item.label}
                                                                        onDelete={this.handleDelete({ key: item.key, label: item.label, filter: item }, client)}
                                                                        className="filter-chip"
                                                                    />
                                                                </a>
                                                                <ReactTooltip id={item.field} place="bottom" aria-haspopup="true" effect="solid" type="light">
                                                                    {
                                                                        (dataFilter.data[item.dataName].filter((itemFilter: any) => {
                                                                            if (item.filterChecked.indexOf(itemFilter.id.toString()) > -1) {
                                                                                return true;
                                                                            }

                                                                            return false;
                                                                        }).map((itemFilter: any, key: any) => {
                                                                            return <div key={key} className="tooltip-chip">
                                                                                {itemFilter[item.queryField]}
                                                                            </div>
                                                                        }))
                                                                }
                                                                </ReactTooltip>
                                                            </div>
                                                        );
                                                    }}
                                            </Query>
                                        </div>
                                    )
                                    }
                                )}
                            </div>
                            </Paper></div> : '')}}
                </Query>)
    }

    private handleDelete = (data: IChipData, client: any) => {
        return () => {
            if (data.key === 1){
                client.writeData({ data: {
                    FILTER_marketBookstoreStoreFilterChecked: [],
                } });
            }

            QueryFilter.updateMutationMarketBookstore();
        }
    };
}

export const GetArrayFilters = (data: any) => {
    const arrayFilter = [];

    if (data.FILTER_marketBookstoreStoreFilterChecked.length > 0){
        arrayFilter.push({
            dataName: 'marketBookstoreStoreFilter',
            field: 'store',
            filterChecked: data.FILTER_marketBookstoreStoreFilterChecked,
            key:1,
            label:'Livrarias',
            query: MARKET_BOOKSTORE_STORE_FILTER,
            queryField: 'name',
        });
    }
    return arrayFilter;
};



// WEBPACK FOOTER //
// ./src/component/market/bookstore/shared/chips/MarketBookstoreChip.tsx